/* eslint-disable linebreak-style */
/* eslint-disable import/extensions */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import emailjs from '@emailjs/browser';

import Header from 'parts/Header';
import Footer from 'parts/Footer';
import ParticleBackground from '../elements/ParticleBackground';

const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_CONTACT_TEMPLATE;
const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

const initialState = {
  name: '', email: '', company: '', message: '',
};

export function DiscussProjectPage() {
  const [form, setForm] = useState(initialState);
  const [status, setStatus] = useState({ state: 'idle', message: '' });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleChange = (e) => {
    setForm((p) => ({ ...p, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!SERVICE_ID || !TEMPLATE_ID || !PUBLIC_KEY) {
      setStatus({ state: 'error', message: 'Email service is not configured.' });
      return;
    }
    setStatus({ state: 'sending', message: '' });
    try {
      await emailjs.send(
        SERVICE_ID,
        TEMPLATE_ID,
        {
          name: form.name,
          email: form.email,
          company: form.company || '—',
          message: form.message,
          reply_to: form.email,
        },
        { publicKey: PUBLIC_KEY },
      );
      setStatus({
        state: 'success',
        message: 'Thanks! Your message is in our inbox — we’ll respond within one business day.',
      });
      setForm(initialState);
    } catch (err) {
      setStatus({
        state: 'error',
        message: 'Something went wrong sending the message. Please email info@web7labs.com directly.',
      });
    }
  };

  const isSending = status.state === 'sending';

  return (
    <div className="neon-theme min-h-screen">
      <Header />
      <ParticleBackground />

      <section className="container mx-auto px-4 lg:px-8 relative z-10">
        <div className="services-hero">
          <span className="section-eyebrow">Contact</span>
          <h1>
            Let&apos;s build something <span className="neon-text">great</span>
          </h1>
          <p>Tell us about your project. We typically respond within one business day.</p>
        </div>
      </section>

      <section className="container mx-auto px-4 lg:px-8 pb-20 relative z-10">
        <div className="max-w-6xl mx-auto contact-grid">
          <div className="contact-form">
            {status.state === 'success' ? (
              <div className="text-center py-8">
                <div className="text-5xl mb-3">✓</div>
                <h3 className="text-2xl font-bold text-white mb-2">Message sent</h3>
                <p className="text-blue-100">{status.message}</p>
                <button
                  type="button"
                  onClick={() => setStatus({ state: 'idle', message: '' })}
                  className="mt-6"
                >
                  Send another message
                </button>
              </div>
            ) : (
              <form onSubmit={handleSubmit}>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                  <div>
                    <label htmlFor="name">Your Name *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={form.name}
                      onChange={handleChange}
                      required
                      placeholder="John Doe"
                      disabled={isSending}
                    />
                  </div>
                  <div>
                    <label htmlFor="email">Email Address *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={form.email}
                      onChange={handleChange}
                      required
                      placeholder="john@example.com"
                      disabled={isSending}
                    />
                  </div>
                </div>

                <div className="mb-6">
                  <label htmlFor="company">Company Name</label>
                  <input
                    type="text"
                    id="company"
                    name="company"
                    value={form.company}
                    onChange={handleChange}
                    placeholder="Your Company"
                    disabled={isSending}
                  />
                </div>

                <div className="mb-6">
                  <label htmlFor="message">Project Details *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={form.message}
                    onChange={handleChange}
                    required
                    rows="6"
                    placeholder="Tell us about your project..."
                    disabled={isSending}
                  />
                </div>

                {status.state === 'error' && (
                  <div className="form-status-error">{status.message}</div>
                )}

                <div className="text-left">
                  <button type="submit" disabled={isSending}>
                    {isSending ? 'Sending…' : 'Send Message'}
                    {!isSending && (
                      <svg className="w-4 h-4 ml-2 inline-block" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                      </svg>
                    )}
                  </button>
                </div>
              </form>
            )}
          </div>

          <div>
            <div className="contact-info-card">
              <h3>Reach us directly</h3>
              <a href="mailto:info@web7labs.com" className="contact-info-row">
                <svg fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                </svg>
                info@web7labs.com
              </a>
              <div className="contact-info-row">
                <svg fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                </svg>
                Model Town C Block, Lane 23, Lahore
              </div>

              <div className="contact-info-divider" />

              <h3>Response time</h3>
              <p className="text-gray-400 text-sm leading-relaxed">
                We respond to all inquiries within one business day.
              </p>

              <div className="contact-info-divider" />

              <h3>What happens next</h3>
              <ul className="text-gray-300 text-sm space-y-2 mt-2">
                <li>• Quick discovery call (30 min)</li>
                <li>• Tailored proposal within a week</li>
                <li>• Senior team kickoff on day one</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default DiscussProjectPage;
